import 'react-dates/initialize';
import React, { Component } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import { connectRange } from 'react-instantsearch-dom'
import moment from '../utils/momentTimeZone';

const DateRefinement = connectRange(({
    refine
}) => {
    return <DateRefinementPicker refine={refine} />
})


class DateRefinementPicker extends Component {

    constructor(props) {
        super(props)
        this.state = {
            startDate: moment(),
            endDate: null,
            focusedInput: null
        }

        this.refine = props.refine

        this.smallDevice = window.matchMedia ? window.matchMedia('(max-width: 650px)').matches : false;
        this.orientation = this.smallDevice ? 'vertical' : 'horizontal';
        this.numMonths = this.smallDevice ? 6 : 2;

        this.applyRefinement = this.applyRefinement.bind(this)
    }

    applyRefinement({ startDate, endDate }) {
        if(!startDate) {
            startDate = moment()
        }
        this.setState({ startDate, endDate })
        this.refine({min: startDate.unix(), max: endDate ? endDate.utc().unix() : undefined})
    }

    render() {
        const {smallDevice, numMonths, orientation} = this
        return (
            <DateRangePicker
                ref={this.child}
                displayFormat="DD MMM YYYY"
                readOnly
                withPortal
                showClearDates
                withFullScreenPortal={smallDevice}
                numberOfMonths={numMonths}
                orientation={orientation}
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId="whats-on-filterStartDate"
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId="whats-on-filterEndDate"
                onDatesChange={this.applyRefinement} // PropTypes.func.isRequired,
                onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput}
            />
        );
    }
}

export default DateRefinement;



// WEBPACK FOOTER //
// ./src/whatson/components/DateRefinement.js